import { useEffect, useState } from "react";
import styled from "styled-components";

interface VinculoTagProps {
  id: string;
  operacao: any;
  planejamentos: any[];
}

function VinculoTag({ id, operacao, planejamentos }: VinculoTagProps) {

  const [operacaoVinculada, setOperacaoVinculada] = useState<string>();

  function getOperacaoVinculada() {
    if (id && operacao.planoOperacionalReferencia === "Operação Vinculada") {
      const operacoes = planejamentos.map(p => p.planoOperacionalOperacoes).flat();
      const vinculo = operacoes.find(o => o.planoOperacionalOperacaoId === id);
      setOperacaoVinculada(`Operação ${vinculo.sequencia}`);
      return;
    }
    setOperacaoVinculada(undefined);
  }

  useEffect(() => {
    getOperacaoVinculada();
  }, [id, operacao]);

  return (
    <>
      {operacaoVinculada ? (
        <Container>
          <p>{operacaoVinculada}</p>
        </Container>
      ) : (
        <span>-</span>
      )}
    </>
  );
}

const Container = styled.div`
  padding: 6px;
  border-radius: 15px;
  font-weight: bold;
  color: #1976d2;
  background-color: #e3f2fd;
`;

export default VinculoTag;
